import { ActivatedRouteSnapshot } from "@angular/router";
import {Injectable} from "@angular/core";

export interface ComponentCanDeactivate {
  canDeactivate: () => boolean;
  pendingChangesDisabled: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PendingChangesGuard  {
  listenerFn: () => void;
  pendingChangesDisabled: boolean;

  constructor() {
    this.pendingChangesDisabled = (localStorage.getItem('pending-changes-disabled') ?? 'false') === 'true';
  }

  canDeactivate(component: ComponentCanDeactivate, currentRoute: ActivatedRouteSnapshot): boolean {
    if (this.pendingChangesDisabled) {
      return true;
    }

    if (component) {
      if (component.canDeactivate == null) {
        console.error('ERROR: canDeactivate not implemented');
        return true;
      }
      if (component.canDeactivate()) {
        return true;
      } else {
        return confirm('WARNING: You have unsaved changes. Press Cancel to go back and save changes, or OK to lose changes.');
      }
    }

    return true;
  }
}
